export default __webpack_public_path__ + "static/media/stop_zing.87eb16c1.png";